module.exports = __webpack_public_path__ + "img/организация.d112d722.svg";